/**
 * Nitrox Republic — Swatch Hover Preview v6
 *
 * capture:true ensures this fires BEFORE any child stopPropagation.
 * Clearing srcset before setting src avoids browser srcset priority issues.
 */
(function () {
  'use strict';

  var variantImageMap = {};
  var savedSrc    = null;
  var savedSrcset = null;
  var activeImg   = null;
  var restoreTimer = null;

  function getMainImg() {
    return (
      document.querySelector('media-gallery slideshow-slide[aria-hidden="false"] img') ||
      document.querySelector('media-gallery slideshow-slide img') ||
      document.querySelector('.product-media-container img')
    );
  }

  function buildSrcset(base) {
    return [400, 700, 1000, 1200]
      .map(function (w) { return base + '?width=' + w + ' ' + w + 'w'; })
      .join(', ');
  }

  function restore() {
    if (activeImg && savedSrc) {
      activeImg.srcset = savedSrcset;
      activeImg.src    = savedSrc;
    }
    savedSrc = savedSrcset = activeImg = null;
  }

  // capture:true — fires on the way DOWN the DOM tree,
  // before any child element can call stopPropagation
  document.addEventListener('mouseover', function (e) {
    clearTimeout(restoreTimer);

    var label = e.target.closest('.variant-option__button-label--has-swatch');

    if (label) {
      var input = label.querySelector('input[data-variant-id]');
      if (!input) return;
      var base = variantImageMap[input.getAttribute('data-variant-id')];
      if (!base) return;

      var img = getMainImg();
      if (!img) return;

      if (!savedSrc) {
        savedSrc    = img.src;
        savedSrcset = img.srcset || '';
        activeImg   = img;
      }

      // Clear srcset first so browser doesn't ignore src change
      img.srcset = '';
      img.src    = base + '?width=1000';
      img.srcset = buildSrcset(base);
      return;
    }

    // Cursor moved off swatches — restore
    if (savedSrc) {
      restoreTimer = setTimeout(restore, 80);
    }
  }, true); // <-- capture phase

  function loadMap() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    fetch('/products/' + m[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        data.variants.forEach(function (v) {
          if (v.featured_image && v.featured_image.src) {
            variantImageMap[String(v.id)] = v.featured_image.src.replace(/[?#].*$/, '');
          }
        });
      })
      .catch(function () {});
  }

  if (window.location.pathname.indexOf('/products/') !== -1) {
    loadMap();
  }

})();
